/** QA/QC overview dashboard tab ids (Oil CCE | Gas CCE | DL). */

export const QAQC_OVERVIEW_TAB_OIL_CCE = "oilCce";
export const QAQC_OVERVIEW_TAB_GAS_CCE = "gasCce";
export const QAQC_OVERVIEW_TAB_DL = "dlTests";

const VALID_TABS = new Set([
  QAQC_OVERVIEW_TAB_OIL_CCE,
  QAQC_OVERVIEW_TAB_GAS_CCE,
  QAQC_OVERVIEW_TAB_DL,
]);

export function isValidQaqcOverviewTab(tab) {
  return VALID_TABS.has(tab);
}

export function parseQaqcOverviewTabFromQuery(query) {
  if (!query || typeof query !== "object") return null;
  const raw = query.qaqcOverviewTab;
  const tab = Array.isArray(raw) ? raw[0] : raw;
  return isValidQaqcOverviewTab(tab) ? tab : null;
}

export function overviewTabFromFluidTypeQuery(query) {
  if (!query || typeof query !== "object") return QAQC_OVERVIEW_TAB_OIL_CCE;
  const raw = query.fluidType;
  const s = Array.isArray(raw) ? raw[0] : raw;
  const inner = String(s ?? "")
    .replace(/^["']+|["']+$/g, "")
    .toLowerCase();
  if (inner === "gas" || inner.includes("gas")) {
    return QAQC_OVERVIEW_TAB_GAS_CCE;
  }
  return QAQC_OVERVIEW_TAB_OIL_CCE;
}

export function overviewTabFromTestRoute(route) {
  const fromQuery = parseQaqcOverviewTabFromQuery(route?.query);
  if (fromQuery) return fromQuery;

  const testType = String(route?.params?.testType ?? "").toLowerCase();
  if (testType.includes("dl")) return QAQC_OVERVIEW_TAB_DL;
  if (
    testType.includes("cce") ||
    testType.includes("cvd") ||
    testType.includes("composition")
  ) {
    return overviewTabFromFluidTypeQuery(route?.query);
  }
  return QAQC_OVERVIEW_TAB_OIL_CCE;
}

export function overviewTabFromNavigationTarget(navigationTarget, listQuery = {}) {
  if (navigationTarget?.testKind === "dl") return QAQC_OVERVIEW_TAB_DL;
  return overviewTabFromFluidTypeQuery(listQuery);
}

export function overviewTabFromDatasetLabel(datasetLabel) {
  const label = String(datasetLabel ?? "").toLowerCase();
  if (label.includes("dl")) return QAQC_OVERVIEW_TAB_DL;
  if (label.includes("gas")) return QAQC_OVERVIEW_TAB_GAS_CCE;
  return QAQC_OVERVIEW_TAB_OIL_CCE;
}

export function overviewTabFromDistributionNavContext(ctx) {
  if (ctx === "dl") return QAQC_OVERVIEW_TAB_DL;
  if (ctx === "gas") return QAQC_OVERVIEW_TAB_GAS_CCE;
  return QAQC_OVERVIEW_TAB_OIL_CCE;
}

export function mergeOverviewTabIntoQuery(query, overviewTab) {
  const out = { ...(query || {}) };
  if (isValidQaqcOverviewTab(overviewTab)) {
    out.qaqcOverviewTab = overviewTab;
  }
  return out;
}
